theme.headerSticky = (function() {
  function ScrollSticky() {
    const headerStickyWrapper = document.querySelector('header');
    const headerStickyTarget = document.querySelector('.header__sticky');
    if (!headerStickyWrapper || !headerStickyTarget) return;

    const categoryNav = headerStickyWrapper.querySelector('.kl-category-nav');
    const headerInner = headerStickyWrapper.querySelector('.header__inner');
    const logo = headerStickyWrapper.querySelector('.header__logo');
    const originalParent = categoryNav ? categoryNav.parentElement : null;
    const originalNext = categoryNav ? categoryNav.nextElementSibling : null;

    let headerHeight = headerStickyWrapper.clientHeight;
    let lastScrollY = window.scrollY;

    const moveCategoryIntoHeader = () => {
      if (!categoryNav || !headerInner) return;
      if (headerInner.contains(categoryNav)) return;
      if (logo && logo.parentElement === headerInner) {
        headerInner.insertBefore(categoryNav, logo);
      } else {
        headerInner.insertBefore(categoryNav, headerInner.firstChild);
      }
    };

    const moveCategoryBack = () => {
      if (!categoryNav || !originalParent) return;
      if (originalNext && originalNext.parentElement === originalParent) {
        originalParent.insertBefore(categoryNav, originalNext);
      } else {
        originalParent.appendChild(categoryNav);
      }
    };

    const setStickyState = (isSticky, isCompact) => {
      headerStickyTarget.classList.toggle('sticky', isSticky);
      headerStickyWrapper.classList.toggle('kl-header--stuck', isSticky);
      headerStickyWrapper.classList.toggle('kl-header--compact', isSticky && isCompact);
      if (isSticky && isCompact) {
        moveCategoryIntoHeader();
      } else {
        moveCategoryBack();
      }
      if (isSticky) {
        headerStickyWrapper.style.setProperty(
          '--kl-sticky-header-height',
          `${headerStickyTarget.offsetHeight}px`
        );
      } else {
        headerStickyWrapper.style.removeProperty('--kl-sticky-header-height');
      }
    };

    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const isSticky = currentScrollY > headerHeight;
      const isScrollingDown = currentScrollY > lastScrollY;
      if (isSticky) {
        setStickyState(true, isScrollingDown);
      } else {
        setStickyState(false, false);
      }
      lastScrollY = currentScrollY;
    };

    const handleResize = () => {
      headerHeight = headerStickyWrapper.clientHeight;
      if (headerStickyTarget.classList.contains('sticky')) {
        headerStickyWrapper.style.setProperty(
          '--kl-sticky-header-height',
          `${headerStickyTarget.offsetHeight}px`
        );
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleResize);
    handleResize();
    handleScroll();
  }

  return ScrollSticky;
})();


